import { useEffect } from 'react';
import { MDText } from 'i18n-react';

import { Button, CrossIcon, TickIcon } from '@motorway/mw-highway-code';

import { triggerBulkBiddingCancelButtonClicked } from 'Services/analytics/events/bulkBiddingEvents/triggerBulkBiddingCancelButtonClicked';
import { triggerBulkBiddingModalOpened } from 'Services/analytics/events/bulkBiddingEvents/triggerBulkBiddingModalOpened';

import bulkBiddingModalTexts from '../../BulkBidding.texts';
import type { ActionableVehicle, UnactionableVehicle } from '../../useFetchVehiclesForBulkBiddingCSV';
import { Description } from '../Description/Description';
import { BULK_BIDDING_VIEW_NAMES } from '../useBulkBiddingModalViewName';
import { VehicleTable } from '../VehicleTable/VehicleTable';

import styles from './ConfirmationView.module.scss';

const LocalT = new MDText(bulkBiddingModalTexts.confirmationView);

interface ConfirmationViewProps {
	actionableVehicles: ActionableVehicle[];
	handleCreateBids: () => void;
	handleDismissModal: () => void;
	isCreatingBids: boolean;
	unactionableVehicles: UnactionableVehicle[];
}

export const ConfirmationView: React.FC<ConfirmationViewProps> = ({
	actionableVehicles,
	handleCreateBids,
	handleDismissModal,
	isCreatingBids,
	unactionableVehicles,
}) => {
	const allVehicles = [...actionableVehicles, ...unactionableVehicles];

	useEffect(() => {
		triggerBulkBiddingModalOpened(BULK_BIDDING_VIEW_NAMES.CONFIRMATION);
	}, []);

	return (
		<div className={styles.container}>
			<Description
				heading={LocalT.translate('heading')}
				infoText={LocalT.translate('info', {
					numberOfVehicles: allVehicles.length,
					pluralisation: allVehicles.length === 1 ? '' : 's',
				})}
				noteText={LocalT.translate('note')}
			/>
			<VehicleTable modalStage={BULK_BIDDING_VIEW_NAMES.CONFIRMATION} vehicles={allVehicles} />
			<div className={styles.buttonContainer}>
				<Button
					reverse
					disabled={isCreatingBids}
					icon={TickIcon}
					label={LocalT.translate('buttons.placeBids')}
					onClick={handleCreateBids}
				/>
				<Button
					reverse
					disabled={isCreatingBids}
					icon={CrossIcon}
					label={LocalT.translate('buttons.cancel')}
					onClick={() => {
						triggerBulkBiddingCancelButtonClicked();
						handleDismissModal();
					}}
					variant={'secondary'}
				/>
			</div>
		</div>
	);
};
